import cn from "classnames";
import propTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";
import BackgroundOverlay from "v2/components/templates/BackgroundOverlay";
import FormContainer from "v2/components/templates/FormContainer";
import HeroImage from "v2/components/templates/HeroImage";
import Logo from "v2/components/templates/Logo";
import TemplateContainer from "v2/components/templates/TemplateContainer";
import Text from "v2/components/templates/Text";
import { templateStyles } from "v2/components/templates/styles/version-12";
import styleHelper from "v2/styles/style-helper";

const styles = {
  topLogoContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#fff",
    zIndex: 4,
    padding: 22,
  },
  background: {
    position: "relative",
    width: "100%",
    padding: (props) => (props.desktopVersion ? "154px 0" : "100px 0"),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    overflow: "hidden",
    [styleHelper.max(1100)]: {
      padding: "100px 0",
    },
  },
  backgroundParalax: {
    position: "relative",
    overflow: "hidden",
  },
  formContainer: {
    width: "100%",
    overflow: "auto",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    margin: "0 auto 20px auto",
  },
  headlineContainer: {
    position: "relative",
    zIndex: 1,
    width: "calc(100% - 40px)",
  },
  preEntryMessageContainer: {
    position: "relative",
    width: "calc(100% - 40px)",
    margin: "40px 0",
    zIndex: 1,
  },
  detailsContainer: {
    margin: (props) => (props.desktopVersion ? "60px auto 0 auto" : "60px 20px 0 20px"),
    maxWidth: 680,
    width: (props) => (props.desktopVersion ? "100%" : "calc(100% - 40px)"),
    [styleHelper.max(720)]: {
      margin: "20px !important",
      width: "calc(100% - 40px) !important",
    },
  },
  ...templateStyles,
};

class Version12 extends React.Component {
  static propTypes = {
    opts: propTypes.object.isRequired,
    classes: propTypes.object.isRequired,
    desktopVersion: propTypes.bool,
    isEditorMenuOpen: propTypes.bool,
  };

  static defaultProps = {
    desktopVersion: true,
    isEditorMenuOpen: false,
  };

  static childContextTypes = {
    baseStyles: propTypes.object,
    userStyles: propTypes.object,
    brightness: propTypes.string,
  };

  getChildContext() {
    const {
      classes: css,
      opts: {
        elements: { styles: userStyles },
      },
    } = this.props;

    return {
      baseStyles: css,
      userStyles,
      brightness: "light",
    };
  }

  render() {
    const {
      opts: {
        campaign,
        hostBrand,
        elements,
        termsLink,
        acceptedInvites,
        elements: { styles: userStyles },
      },
      updateElementsAttr,
      editElements,
      customFonts,
      edit,
      updateAttr,
      agreeToLiability,
      desktopVersion,
      classes: css,
      isEditorMenuOpen,
    } = this.props;

    const formStyles = userStyles.form;

    return (
      <TemplateContainer
        campaign={campaign}
        elements={elements}
        isFixedBackgroundImage={false}
        updateAttr={updateElementsAttr}
        campaignUpdateAttr={updateAttr}
        desktopVersion={desktopVersion}
        acceptedInvites={acceptedInvites}
        isEditorMenuOpen={isEditorMenuOpen}
        hostBrand={hostBrand}
      >
        <div id="top-logo-container" className={css.topLogoContainer}>
          <Logo
            hostWebsite={hostBrand.website}
            logoPath={elements.top_logo || hostBrand.logo}
            updateAttr={updateElementsAttr}
            edit={editElements}
            campaign={campaign}
            elements={elements}
            maxHeight={elements.styles.topLogo ? elements.styles.topLogo.height : 100}
            className={css.topLogoImg}
            id="top-logo"
            allowDelete
            editName="top-logo"
          />
        </div>
        <div className={cn(css.backgroundParalax, "background-parallax")}>
          <div className={css.background}>
            <Text
              model={elements}
              updateAttr={updateElementsAttr}
              edit={editElements}
              attr="headLine"
              customFonts={customFonts}
              className={css.headlineContainer}
              width={desktopVersion ? "calc(100% - 160px)" : "100%"}
            />

            <Text
              model={elements}
              updateAttr={updateElementsAttr}
              edit={editElements}
              attr="preEntryMessage"
              customFonts={customFonts}
              className={css.preEntryMessageContainer}
              width={desktopVersion ? "calc(100% - 160px)" : "100%"}
            />

            <HeroImage imageUrl={elements.mainImage} desktopVersion={desktopVersion} />
            <BackgroundOverlay desktopVersion={desktopVersion} />
          </div>
        </div>
        <div
          className={css.formContainer}
          style={{ background: `${formStyles.color}` }}
          id="form-holder"
        >
          <Text
            model={elements}
            updateAttr={updateElementsAttr}
            edit={editElements}
            attr="details"
            customFonts={customFonts}
            className={css.detailsContainer}
          />
          <FormContainer
            updateAttr={updateAttr}
            updateElementsAttr={updateElementsAttr}
            campaign={campaign}
            elements={elements}
            edit={edit}
            editElements={editElements}
            termsLink={termsLink}
            agreeToLiability={agreeToLiability}
            acceptedInvites={acceptedInvites}
            customFonts={customFonts}
            desktopVersion={desktopVersion}
          />
        </div>
      </TemplateContainer>
    );
  }
}

export default injectSheet(styles)(Version12);
